<template>
    <div class="container">

        <div class="simulator-box">

             <div class="flex-row">
                <div class="col-xs">
                    <h2 class="simulator-title" :class="{'with-animation' : carregando}">
                        Projetos Futuros
                    </h2>
                </div>
                <div class="col-xs flex-no-grow">
                    <a @click="adicionar()" class="btn-floating waves-effect waves-light btn-default">
                        <i class="material-icons">add</i>
                    </a>
                </div>
            </div>



            <div class="card-panel" v-for="(projeto, index) in projetos" :key="index">

                <div class="flex-row bottom-xs mb-5">
                    <div class="col-xs flex-no-grow">
                        <i class="material-icons simulador-icon">attach_money</i>
                    </div>
                    <div class="col-xs-12 col-sm">
                        <label>Nome do projeto</label>
                        <input type="text" class='form-control m-0' v-model.trim="projeto.nome" @input="salvar(projeto, index)">
                    </div>
                    <div class="col-xs-12 col-sm-2">
                        <label>Valor restante</label>
                        <input type="text" class="form-control m-0" :value="$options.filters.dinheiro(projeto.valor_necessario - projeto.valor_reserva)" readonly tabindex="-1">
                    </div>

                    <div class="col-xs-12 col-sm-2">
                        <label>Anos restantes</label>
                        <input type="text" value="0" class="form-control m-0" v-model="projeto.tempo_necessario" readonly tabindex="-1">
                    </div>
                    <div class="col-xs-12 col-sm-2">
                        <label>Aporte mensal</label>
                        <input type="text"  class="form-control m-0" :value="$options.filters.dinheiro(projeto.necessidade_investimento)" readonly>
                    </div>
                    <div class="col-xs-12 col-sm-2">
                        <div class="input-field actions end-xs">
                            <a class="delete-button text-primary" @click="confirmarExclusao(projeto, index)" tabindex="-1">
                                <i class="material-icons">delete</i>
                            </a>
                            <router-link
                                :to="{params: {projeto_id: projeto.projeto_id, cliente_id: projeto.cliente_id}, name: 'projeto'}"
                                class="btn-floating waves-effect waves-light btn-default"
                                :disabled="!projeto.projeto_id || !projeto.nome">
                                <i class="material-icons">keyboard_arrow_right</i>
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card-panel">
                  <div class="flex-row bottom-xs">
                    <div class="col-xs">
                        <strong>VALOR RESTANTE TOTAL:</strong>
                    </div>
                    <div class="col-xs end-xs">{{ valor_restante_total | dinheiro }}</div>
                </div>

                <div class="flex-row bottom-xs">
                    <div class="col-xs">
                        <strong>VALOR DE APORTE MENSAL TOTAL:</strong>
                    </div>
                    <div class="col-xs end-xs">{{ aporte_mensal_total | dinheiro }}</div>
                </div>
            </div>

            <footer-simulador :loading.sync="carregando" />
        </div>


    </div>

</template>


<script>

import {api} from "@/helpers/api";
import debounce from "lodash/debounce";
import "@/../static/assets/css/custom/flex.css";

import modal from '@/helpers/wm-modal.js'

import FooterSimulador from '@/components/common/FooterSimulador';


export default {

    components: { FooterSimulador },

    async created() {

        const {data: {result: {data: cliente}}}  = await api.get(`cliente/${this.$route.params.id}`);

        this.projetos = cliente.projetos


        this.projetos.length || this.adicionar()

    },

    computed:
    {
        aporte_mensal_total() {
            return this.somaCampo('necessidade_investimento');
        },

        valor_restante_total() {
            return this.projetos.reduce((soma, projeto) => {
                return projeto.valor_necessario - projeto.valor_reserva + soma
            }, 0)
        },
    },
    data() {

        return {
            carregando: false,
            projetos: [],
        }
    },

    methods: {

        somaCampo(campo) {
            return this.projetos.reduce((soma, projeto) => {
                return parseFloat(projeto[campo]) + soma
            }, 0)
        },

        adicionar() {

            this.projetos.push({
                nome: '',
                cliente_id: this.$route.params.id,
                necessidade_investimento: 0
            })
        },



        async confirmarExclusao(projeto, index)
        {
            const resultado = await modal.confirm({
                text: "Confirma a exclusão desse item?",
                title: "Confirmação"
            })

            if (! resultado) return;

            await this.excluir(projeto, index);
        },


        async excluir(projeto, index) {

            if (projeto.projeto_id) {
                await api.delete(`projeto/${projeto.projeto_id}`)
            }

            this.projetos.splice(index, 1);
        },


        salvar: debounce(async function (projeto, index) {

            if (! projeto.nome) {
                return;
            };

            if (this.carregando) return;

            this.carregando = true;


            try{

                if (projeto.projeto_id)
                {
                    await api.put(`projeto/${projeto.projeto_id}`, {nome: projeto.nome});

                } else {

                    const {data: {result: {data: resultado}}} = await api.post('projeto', projeto);

                    this.$set(this.projetos, index, resultado);
                }

            } finally {
                setTimeout(() => this.carregando = false, 2000);
            }

        }, 500)
    }
}

</script>


<style lang="scss" scoped>

#input-rentabilidade{

    margin: 0;
    height: auto;
    width: 40px;
    padding: 5px;


    &::-webkit-inner-spin-button,
    &::-webkit-outer-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }
}

.text-active{
    color: var(--color-primary);
    font-weight: bold;
}

.item-checkbox{
    padding: 10px 0;

}

.delete-button{
    margin-top: 5px;
    margin-right: 10px;
    cursor: pointer;
}

.actions{
    display: flex;
    align-items: center;
}


</style>



// WEBPACK FOOTER //
// src/components/clientes/Projetos.vue